module.exports = __webpack_public_path__ + "img/banner14m.762fde39.png";